import { motion } from 'framer-motion';
import React from 'react';

import S from './Modal.module.scss';

export interface ModalProps {
  heading: string;
  description: string;
  leftButton: {
    label: string;
    onClick: () => void;
  };
  rightButton: {
    label: string;
    onClick: () => void;
  };
}

const Modal: React.FC<ModalProps> = ({
  heading,
  description,
  leftButton,
  rightButton,
  ...rest
}) => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.3 } }}
      exit={{ opacity: 0, transition: { duration: 0.2 } }}
      className={S.Modal}
      {...rest}
    >
      <div className={S.ContentWrapper}>
        <div className={S.TextWrapper}>
          <h4 className={S.Title}>{heading}</h4>

          <p className={S.Description}>{description}</p>
        </div>

        <div className={S.ButtonContainer}>
          {leftButton.label && (
            <button onClick={leftButton.onClick} className={S.Button}>
              {leftButton.label}
            </button>
          )}

          {rightButton.label && (
            <button onClick={rightButton.onClick} className={S.Button}>
              {rightButton.label}
            </button>
          )}
        </div>
      </div>
    </motion.div>
  );
};

export default Modal;
